import Vue from 'vue'
import Router from 'vue-router'

// 页面组件全部路由级懒加载（按需分包），避免首页打包进全站工具页代码

// 使用Vue Router插件
Vue.use(Router)

/**
 * 路由配置
 * 定义应用程序的路由规则
 */
const router = new Router({
  mode: 'history', // 使用hash模式，适合单页应用
  routes: [
    {
      path: '/', // 根路径
      name: 'Home',
      component: () => import('@/components/Home'), // 新官网首页（纯展示，React 1:1 还原）
      meta: {
        title: '首页' // 页面标题
      }
    },
    {
      path: '/urlview', // URL展示页面路径
      name: 'UrlView',
      component: () => import('@/components/UrlView'), // URL展示页面组件
      meta: {
        title: 'URL展示页面' // 页面标题
      }
    },
    {
      path: '/webFile', // URL展示页面路径
      name: 'webFile',
      component: () => import('@/components/WebFile'), // 文件上传组件
      meta: {
        title: '文件上传' // 页面标题
      }
    },
    {
      path: '/header-test', // HTTP请求头测试页面路径
      name: 'HeaderTest',
      component: () => import('@/components/HeaderTest'), // HTTP请求头测试页面组件
      meta: {
        title: 'HTTP请求头测试' // 页面标题
      }
    },
    {
      path: '/device-test', // 投屏码设备查询测试页面路径
      name: 'DeviceTest',
      component: () => import('@/components/DeviceTest'), // 投屏码设备查询测试页面组件
      meta: {
        title: '投屏码设备查询测试' // 页面标题
      }
    },
    {
      path: '/dataclean', // 数据清理页面路径
      name: 'dataclean',
      component: () => import('@/components/dataclean'), // 数据清理页面组件
      meta: {
        title: '数据清理' // 页面标题
      }
    },
    {
      path: '/webyun', // 通信测试页面路径
      name: 'webyun',
      component: () => import('@/components/Webyun'), // 通信测试页面组件
      meta: {
        title: '通信测试' // 页面标题
      }
    },
    {
      path: '/qa',
      name: 'QA',
      component: () => import('@/components/QA'),
      meta: {
        title: '常见问题'
      }
    },
    {
      path: '/agent', // AI 搜索对话页路径
      name: 'AgentChat',
      component: () => import('@/components/agent/AgentApp'), // AI 搜索 chat agent 页面（由 web-vue 迁移）
      meta: {
        title: 'AI 搜索' // 页面标题
      }
    },
    {
      path: '*', // 404页面，匹配所有未定义的路由
      redirect: '/' // 重定向到首页
    }
  ]
})

// 百度统计:index.html 已 _setAutoPageview(false) 关闭自动 PV,
// 所有页面(含首次导航)统一在这里上报,不受 hm.js 异步加载时序影响。
router.afterEach((to) => {
  if (window._hmt) {
    window._hmt.push(['_trackPageview', to.fullPath])
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js